import React from "react";

export const SimpleSliderItem = ({ command, command_link, command_text, icon, open_command_new_tab, text, title }) => {
    return (
        <div>
            <h2 className="mb-3 libre-caslon-text-regular h3-md h4">{title}</h2>
            <div className="d-md-flex align-items-start">
                {icon && <div className="profile-avatar mb-2 mx-4 mt-2"><img src={icon} width="80" alt={"slider-icon"} /></div>}
                <div className="mt-2">
                    <div dangerouslySetInnerHTML={{ __html: text}} />
                    {command === true && command_link && command_text && <a className={`btn btn-outline-primary text-uppercase rounded-pill px-md-5`} href={command_link} target={open_command_new_tab ? '_blank' : ''} rel="noopener noreferrer" >{command_text}</a>}
                </div>
            </div>
        </div>
    );
}